// Give each unsaved custom-stat row in the deliverable editor the id the server
// saved it under.
//
// form.vue sends its whole stat list as nested statistics_attributes on every
// autosave (name, url and description all trigger one). A row that never learns
// its id is therefore POSTed as new on every save: deliverable 16599009
// collected six identical impressions estimates in 55 seconds (Kit chat #2262).
// statisticField.vue's single-flight save solved the same thing for a row saved
// from its own field; this is the form-level path.
//
// Match on metric/label/value. If the value was edited while the save was in
// flight, fall back to metric/label when exactly one saved row is unclaimed —
// with two candidates we can't tell which is ours, and guessing wrong would
// point an edit at the wrong row.
//
// `setId(row, id)` lets the caller assign reactively (Vue's $set). Returns the
// number of rows that adopted an id.
export function adoptSavedStatIds(rows, savedStats, setId = (row, id) => (row.id = id)) {
  const claimed = new Set((rows || []).filter((s) => s.id).map((s) => s.id));
  const sameSlot = (a, b) =>
    String(a.metric_type || "") === String(b.metric_type || "") &&
    String(a.label || "") === String(b.label || "");
  let adopted = 0;

  (rows || []).forEach((row) => {
    if (row.id || (!row.metric_type && !row.label)) return;
    const unclaimed = (savedStats || []).filter(
      (s) => s.id && !claimed.has(s.id) && sameSlot(s, row)
    );
    const match =
      unclaimed.find((s) => String(s.value || "") === String(row.value || "")) ||
      (unclaimed.length === 1 ? unclaimed[0] : null);
    if (match) {
      setId(row, match.id);
      claimed.add(match.id);
      adopted += 1;
    }
  });

  return adopted;
}
